import React from 'react'

import Breadcrumbs from '../../components/common/Breadcrumbs/Breadcrumbs.tsx'
import Card from '../../components/common/Card/Card.tsx'
import PatientProfiles from '../../components/patientProfiles/PatientProfiles.tsx'

const PatientProfilesList = () => {
  return (
    <React.Fragment>
      <Breadcrumbs pageName="Pacjenci" breadcrumbs={[]} />

      <Card className="w-full">
        <Card.Body>
          <PatientProfiles />
        </Card.Body>
      </Card>
    </React.Fragment>
  )
}

export default PatientProfilesList
